module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/close-dark-11a43cc635a9047d8bc25ff7b89c5f23.svg";